// 判断参数是否是其中之一
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

// Find components upward
export function findComponentUpward(context, componentName, componentNames) {
  if (typeof componentName === 'string') {
    componentNames = [componentName]
  } else {
    componentNames = componentName
  }

  let parent = context.$parent
  let name = parent.$options.name
  while (parent && (!name || componentNames.indexOf(name) < 0)) {
    parent = parent.$parent
    if (parent) name = parent.$options.name
  }
  return parent
}

const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g
const MOZ_HACK_REGEXP = /^moz([A-Z])/

function camelCase(name) {
  return name
    .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter
    })
    .replace(MOZ_HACK_REGEXP, 'Moz$1')
}

// getStyle
export function getStyle(element, styleName) {
  if (!element || !styleName) return null
  styleName = camelCase(styleName)
  if (styleName === 'float') {
    styleName = 'cssFloat'
  }
  try {
    const computed = document.defaultView.getComputedStyle(element, '')
    return element.style[styleName] || computed ? computed[styleName] : null
  } catch (e) {
    return element.style[styleName]
  }
}

// 防抖
export function debounce(fn, delay = 500) {
  var timer
  return function() {
    var th = this
    var args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}

// 判断点击的元素 是不是roomContent及其子孙元素
export function isParent(current, target) {
  let classList = current.className
  let flag = false
  if (classList) {
    classList = classList.split(' ')
    classList.forEach(cla => {
      let curNode = document.getElementsByClassName(cla)[0]
      while (curNode !== null) {
        curNode = curNode.parentNode
        if (curNode.className === target || cla === target) {
          flag = true
        }
        if (curNode.nodeName === 'BODY') {
          curNode = null
        }
      }
    })
  } else {
    let curNode = current
    while (curNode !== null) {
      curNode = curNode.parentNode
      if (curNode.className === target) {
        flag = true
      }
      if (curNode.nodeName === 'BODY') {
        curNode = null
      }
    }
  }

  return flag
}
// 深度拷贝
export function deepCopy(obj) {
  const str = JSON.stringify(obj)
  return JSON.parse(str)
}

// 强制保留两位小数
export function changeTwoDecimal_f(x) {
  var f_x = parseFloat(x)
  if (isNaN(f_x)) {
    console.log('function:changeTwoDecimal->parameter error')
    return false
  }
  f_x = Math.round(f_x * 100) / 100
  var s_x = f_x.toString()
  var pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0'
  }
  return s_x
}

/**
 * 枚举类
 *
 * @param props  {}
 * ex:
 *  const StepEnum = new Enum({
    PENDING_PAYMENT: '待付款',
    PANDING_PERFECT: '待完善地址',
    PANDING_INSTALLATION: '待完善地址',
    COMPLETED: '已完成',
    PART_CANCELLED: '部分取消',
    CANCELLED: '已取消'
  },1);
 *
 * @class Enum
 *
 * @method get(value) 通过value获取当前列的值
 *                    return '已取消'
 *
 */
export class Enum {
  /**
   *Creates an instance of Enum.
   * @param {Object} [props={}]
   * @param {number} [beginIndex=0]
   * @param {Array} defaultIndexs
   * @memberof Enum
   */
  constructor(props = {}, beginIndex = 0, defaultIndexs) {
    this.props = props
    this.beginIndex = beginIndex
    this.defaultIndexs = defaultIndexs
    this.__props = {}
    if (defaultIndexs) {
      if (defaultIndexs.length !== Object.keys(props).length) {
        throw new Error('数组与对象个数不一致，怎么回事！')
      }
    }
    if (Object.keys(props).length) {
      Object.keys(props).forEach((key, index) => {
        if (!this.defaultIndexs) {
          if (key) {
            this[key] = beginIndex + index
            this.__props[beginIndex + index] = props[key]
          } else {
            console.error('Enum缺少必要的key或value')
          }
        } else {
          this[key] = this.defaultIndexs[index]
          this.__props[this.defaultIndexs[index]] = props[key]
        }
      })
    }
  }

  /**
   * 根据value获取对象值
   * @param {string|number} value 状态值
   */
  get(value) {
    return this.__props[value]
  }

  /**
   * @description 获取枚举数组
   * @returns {Array}
   * @memberof Enum
   */
  getNames() {
    if (this.defaultIndexs) {
      console.error('传入defaultIndex后不支持getNames方法，若需要使用过滤器，请使用get方法')
      return
    }
    const arr = Object.values(this.props)
    if (this.beginIndex && this.beginIndex > 0) {
      for (let index = 0; index < this.beginIndex; index++) {
        arr.unshift('')
      }
    }
    return arr
  }

  /**
   * @description 返回和ID组成的对象数组，主要用于循环
   * @param {string} [key='id'] 对象的key的名字
   * @param {string} [value='name'] 对象的value的名字
   * @param {boolean} [needAll=false] 是否需要添加全部字段
   * @param {number} [allKey=0] 全部字段对应的key
   * @returns {Array} 对象数组
   * @memberof Enum
   */
  getNameIds(key = 'id', value = 'name', needAll = false, allKey = 0) {
    let nameIds = []
    if (needAll) {
      nameIds.push({
        [key]: allKey,
        [value]: '全部'
      })
    }
    if (!this.defaultIndexs) {
      const arr = this.getNames()
      arr.map((item, index) => {
        if (item) {
          nameIds.push({
            [value]: item,
            [key]: index
          })
        }
      })
    } else {
      this.defaultIndexs.map(item => {
        nameIds.push({
          [value]: this.__props[item],
          [key]: item
        })
      })
    }

    return nameIds
  }
}

/**
 * @description 统计字符串中的字符个数，一个中文等两个字符
 * @param {String} strTemp
 * @returns {Number} 个数
 */
export function getStrLength(strTemp) {
  var i, sum
  sum = 0
  for (i = 0; i < strTemp.length; i++) {
    if (strTemp.charCodeAt(i) >= 0 && strTemp.charCodeAt(i) <= 255) {
      sum = sum + 1
    } else {
      sum = sum + 2
    }
  }
  return sum
}

// 获取类型小写 array object string number boolean undefined
export function typeOf(obj) {
  const str = Object.prototype.toString.call(obj)
  return Object.prototype.toString
    .call(obj)
    .substring(8, str.length - 1)
    .toLowerCase()
}

// 异步加载 script
const scripts = {}
export function loadScript(uri, opts = {}) {
  if (!uri) {
    throw new Error('miss uri')
  }
  if (scripts[uri] === true) {
    return Promise.resolve()
  }
  const head = document.head || document.getElementsByTagName('head')[0] || document.body
  const el = document.createElement('script')
  Object.assign(el, opts)
  el.src = uri
  el.async = true
  // el.crossOrigin = 'anonymous'
  const promise = new Promise((resolve, reject) => {
    el.onload = () => {
      el.onload = null
      scripts[uri] = true
      resolve()
    }
    el.onerror = error => {
      el.onerror = function() {}
      reject(error)
    }
  })
  head.appendChild(el)
  return promise
}

export function groupby(arr) {
  let result = [[]]
  let i = 0
  result[i] = [arr[0]]
  arr.reduce(function(prev, cur) {
    cur - prev === 1 ? result[i].push(cur) : (result[++i] = [cur])
    return cur
  })
  return result
}
